import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LangCtx = createContext(null);

export const useLanguage = () => useContext(LangCtx);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("tsc_lang");
    if (saved === "en" || saved === "fr") return saved;
    return (navigator.language || "en").toLowerCase().startsWith("fr") ? "fr" : "en";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("tsc_lang", l);
  };

  const t = (key) => translations[lang][key] ?? translations.en[key] ?? key;

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLanguage();
  return (
    <div className={`flex items-center gap-1.5 font-jetbrains text-xs uppercase tracking-widest ${className}`} data-testid="lang-toggle">
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-toggle-en"
        className={`transition-colors duration-300 ${lang === "en" ? "text-volt" : "text-white/40 hover:text-white"}`}
      >
        EN
      </button>
      <span className="text-white/20">|</span>
      <button
        type="button"
        onClick={() => setLang("fr")}
        data-testid="lang-toggle-fr"
        className={`transition-colors duration-300 ${lang === "fr" ? "text-volt" : "text-white/40 hover:text-white"}`}
      >
        FR
      </button>
    </div>
  );
};
